import { Link, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';
import { useDarkStore } from '../store/darkStore';
import { useTokens } from '../../hooks/useTokens';

const NAV_LINKS = [
  { to: '/home', label: 'Launchpad' },
  { to: '/spotlight', label: 'Spotlight' },
];

export default function Topbar() {
  const { explorerName: darkExplorerName } = useDarkStore();
  const profile = useAuthStore((s) => s.profile);
  const user = useAuthStore((s) => s.user);
  const { pathname } = useLocation();

  const explorerName = darkExplorerName || profile?.explorerName || '';
  const { balance } = useTokens();

  return (
    <nav
      className="sticky top-0 z-20 border-b border-white/5"
      style={{ background: 'rgba(13,15,28,0.92)', backdropFilter: 'blur(8px)' }}
    >
      <div className="mx-auto flex h-14 max-w-5xl items-center justify-between px-4">
        <Link
          to="/home"
          className="font-marker text-xl tracking-wide"
          style={{ color: '#F59E0B' }}
        >
          OMore
        </Link>

        <div className="flex items-center gap-6">
          {NAV_LINKS.map(({ to, label }) =>
            pathname === to ? (
              <span key={to} className="font-marker text-sm font-bold text-white">
                {label}
              </span>
            ) : (
              <Link
                key={to}
                to={to}
                className="font-marker text-sm transition-colors"
                style={{ color: 'rgba(232,234,240,0.5)' }}
                onMouseEnter={(e) => (e.currentTarget.style.color = 'rgba(232,234,240,0.9)')}
                onMouseLeave={(e) => (e.currentTarget.style.color = 'rgba(232,234,240,0.5)')}
              >
                {label}
              </Link>
            ),
          )}
          {user && (
            <>
              <button
                type="button"
                className="flex items-center gap-1.5 rounded-full px-3 py-1.5 font-marker text-sm font-bold transition-opacity hover:opacity-80"
                style={{ background: '#F59E0B', color: '#0D0F1C' }}
                title="Your token balance"
              >
                <svg className="h-3.5 w-3.5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z" />
                </svg>
                {balance}
              </button>
              <Link
                to="/account"
                title="Account Settings"
                className="max-w-[10rem] truncate font-marker text-sm font-bold transition-opacity hover:opacity-80"
                style={{ color: '#F59E0B' }}
              >
                {explorerName || 'Account'}
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}
